var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    typography = _ref.typography,
    colors = _ref.colors,
    borders = _ref.borders;
  return {
    leftPanelPadding: spacing.xxSmall,
    leftPanelBorderWidth: borders.widthSmall,
    leftPanelBorderColor: colors.contrasts.grey1214,
    rightPanelPadding: spacing.xSmall,
    dragAndDropHandleZIndex: '3333',
    dragAndDropHandleFontSize: typography.fontSizeMedium,
    dragAndDropHandleMargin: spacing.xSmall
  };
};
export default generateComponentTheme;